// @ts-nocheck
import SceneLayer from "./layer";

export default class SceneLayerTraffic extends SceneLayer {
	/**
	 * Vytvoreni vrstvy pro zobrazeni trafficu.
	 */
	constructor(scene, itemId, id, options) {
		super(scene, itemId, id);

		this._data = null;
		this._options = options;
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerTraffic",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.data = this._data;
		rd.options = this._options;

		return rd;
	}

	/**
	 * Smazani vsech entit vrstvy.
	 */
	removeAll(...args) {
		this._data = null;

		this._onChange(this._scene.featureEvent("layerRemoveAll", true, true), args);
	}

	/**
	 * Nastaveni dat.
	 *
	 * @param {Array} data Data z lookupu
	 */
	fillFromData(...args) {
		this._data = args[0];

		this._onChange(this._scene.featureEvent("layerFillFromData", true, true), args);
	}
}
